module.exports = __webpack_public_path__ + "img/logo-ustp-white.d644120.svg";